import { toast } from 'react-toastify'

import { api } from 'api'
import { Info, Success } from 'constants/actionMessages'
import {
  CreateAllConstraintsParams,
  RemovePromoSettingParams,
  UpdateConstraintParams,
} from 'interfaces/store/promoSettings.interfaces'
import { createAction, createAsyncThunk } from 'modules/store'
import { ValidationErrorsApi } from 'packages/api'

export const getAllConstraints = createAsyncThunk('promoSettings/getAllConstraints', async (_, { rejectWithValue }) =>
  api.promoSettings.getAllConstraints().catch((error) => rejectWithValue(error.message)),
)

export const setConstraintsValidationErrors = createAction<ValidationErrorsApi | null>(
  'promoSettings/setConstraintsValidationErrors',
)

export const createAllConstraints = createAsyncThunk(
  'promoSettings/createAllConstraints',
  async (params: CreateAllConstraintsParams, { rejectWithValue, dispatch }) =>
    api.promoSettings
      .createAllConstraints(params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setConstraintsValidationErrors(null))
        toast.success(Success.PromoSettingConstraintCreated)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setConstraintsValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const updateConstraint = createAsyncThunk(
  'promoSettings/updateConstraint',
  async (params: UpdateConstraintParams, { rejectWithValue, dispatch }) =>
    api.promoSettings
      .updateConstraint(params.id, params.data)
      .then((data) => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        dispatch(setConstraintsValidationErrors(null))
        toast.success(Success.Save)
        return data
      })
      .catch((error) => {
        if (error.validation) {
          dispatch(setConstraintsValidationErrors(error.validation))
          return
        }
        return rejectWithValue(error.message)
      }),
)

export const removeConstraint = createAsyncThunk(
  'promoSettings/removeConstraint',
  async (params: RemovePromoSettingParams, { rejectWithValue }) =>
    api.promoSettings
      .remove(params.id)
      .then(() => {
        if (params.onSuccess) {
          params.onSuccess()
        }
        toast.info(Info.PromoSettingConstraintRemoved)
        return
      })
      .catch((error) => rejectWithValue(error.message)),
)
